import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { CloseIcon } from './Styles/Icons';
import { Dialog, DialogActions, DialogTitle, DialogContent, InputGroup, TextField, Number, ButtonGroup, Button, CircularButton, FlexRow } from './Styles/CloneBucketDialogBox';

const CloneBucketDialogBox = ({ open, onTrue, onFalse }) => {
	const [name, setName] = useState('');
	const [discount, setDiscount] = useState(0);
	const [error, setError] = useState(null);

	const onTrueHandler = (percentage) => {
		let errorState = {};
		setError(errorState);

		if (!name) {
			errorState['name'] = 'Bucket name should not be empty.';
		}

		if (percentage < 0) {
			errorState['discount'] = 'Discount percent cannot be negative.';
		} else if (percentage > 100) {
			errorState['discount'] = 'Discount percent cannot be greater than 100.';
		}

		if (Object.keys(errorState).length) {
			setError(errorState);
		} else {
			onTrue({ alias: name, percentage: percentage ? parseFloat(percentage) : percentage });
		}
	};

	useEffect(() => {
		setName('');
		setDiscount(0);
		setError(null);
	}, [open]);

	return (
		<Dialog
			maxWidth='sm'
			fullWidth
			open={open}
			onClose={() => onFalse()}
		>
			<DialogTitle>
				Clone Bucket
				<ButtonGroup alignRight>
					<CircularButton
						error
						outline
						onClick={() => onFalse()}
					>
						<CloseIcon />
					</CircularButton>
				</ButtonGroup>
			</DialogTitle>

			<DialogContent style={{ marginTop: '-30px' }}>
				<FlexRow style={{ padding: '0 1rem' }}>
					<InputGroup
						label='Bucket Name'
						markRequired={true}
						error={error && error.name}
					>
						<TextField
							name='bucket_name'
							placeholder='Enter bucket name'
							value={name}
							disabled={false}
							onChange={(e) => setName(e.target.value)}
							error={error && error.name}
						/>
					</InputGroup>
				</FlexRow>

				<FlexRow style={{ padding: '0 1rem' }}>
					<InputGroup
						label='Discount Percentage (%)'
						message={`This will create a new bucket priced at the selected discount across the catalogue.`}
						error={error && error.discount}
					>
						<Number
							name='discount_percent'
							placeholder='Enter discount percentage'
							value={discount}
							min={0}
							step={0.1}
							disabled={false}
							onChange={(e) => setDiscount(e.target.value)}
							error={error && error.discount}
						/>
					</InputGroup>
				</FlexRow>
			</DialogContent>

			<DialogActions style={{ margin: '0 0.5rem' }}>
				<ButtonGroup alignRight>
					<Button
						primary
						outline
						onClick={(e) => onTrueHandler(null)}
					>
						Create from scratch
					</Button>
					<Button
						primary
						onClick={(e) => onTrueHandler(discount)}
					>
						Create at {discount}% discount
					</Button>
				</ButtonGroup>
			</DialogActions>
		</Dialog>
	);
};

const mapStatesToProps = (state) => {
	return {
		supplier: state.supplier.supplier,
	};
};

const mapFunctionsToProps = {};

export default connect(mapStatesToProps, mapFunctionsToProps)(CloneBucketDialogBox);
